<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <img src="../../assets/croix.png" width="20" height="20" alt="" @click="close" class="cross fright abs pointer" />
                            <CommentPanel :commentData="commentData" :appId="appId" :inPanel="false"></CommentPanel>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import CommentPanel from "./CommentPanel";
export default {
    name: "AllCommentsModal",
    components: { CommentPanel },
    props: ["commentData", "appId"],
    methods: {
        close() {
            this.$emit("closeModal", false);
        }
    }
};
</script>

<style lang="scss" scoped>
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: -10px;
        right: -10px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .modalBody {
            position: relative;
            background: #fff;
            width: 70%;
            height: 600px;
            border-radius: 4px;
            margin: auto;
            .modalContent {
                textarea {
                    width: 80%;
                    height: 200px;
                    background-color: transparent;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    border: 1px #bbb solid;
                    padding: 10px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// AllCommentsModal.vue?20c089ac